import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Banner, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { ContentContainer } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { hasReadOnlyPrivilegesForCustomerData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { AccountBilling } from '../../../billing/AccountBilling/AccountBilling';
import { initializeAccountBilling } from '../../../billing/actions/billing';

export const BillingTab = ({ id }: Identifiable) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const readOnlyForm = useSelector(hasReadOnlyPrivilegesForCustomerData);
    const enterpriseId = useCurrentEnterpriseId();

    useEffect(() => {
        dispatch(initializeAccountBilling({ accountId: id, scope: id }));
    }, [id, dispatch]);

    return (
        <ContentContainer condensed>
            <Stack vertical spacing="200">
                {readOnlyForm && (
                    <Banner
                        centered
                        variant="warning"
                        primaryText={<LocalizedText textKey={TextKey.ReadOnlyPrivilege} />}
                    />
                )}
                <AccountBilling accountId={id} enterpriseId={enterpriseId} scope={id} />
            </Stack>
        </ContentContainer>
    );
};
